import React, {Component} from 'react';
import {purePuzzles} from '../purePuzzles';
import {connect} from 'react-redux';
import {setActivePuzzle} from '../state/activePuzzle';
import {hideAlert} from '../state/showAlert';
import {LanguageContext} from "../App";


class RightMenuDetailsHelp extends Component {
    constructor(props) {
        super(props);

        this.setActivePuzzle = (e) => {
            const puzzle = Object.assign({}, purePuzzles[e.target.dataset.id], {direction: e.target.dataset.direction});
            const currentActivePuzzle = document.querySelector('.active-puzzle');
            let lists = Array.from(document.getElementsByClassName('left-menu-sublist'));
            lists.map(list => {
                list.style.maxHeight = '';
                let icon = list.previousSibling.querySelector('.fas');
                icon.classList.remove('fa-minus');
                icon.classList.add('fa-plus')
                return null;
            });

            if (currentActivePuzzle) {
                currentActivePuzzle.classList.remove('active-puzzle');
                if (!currentActivePuzzle.parentElement.parentElement.querySelector("[src*='" + puzzle.path + "']")) {
                    currentActivePuzzle.parentElement.parentElement.style.maxHeight = '';
                }
            }

            let newActivePuzzle = Array.from(document.getElementsByClassName('menu-puzzle')).find(img =>
                img.src.includes(puzzle.path) && img.classList.contains('menu-puzzle-' + puzzle.direction)
            );
            newActivePuzzle.classList.add('active-puzzle');
            let newActiveList = newActivePuzzle.parentElement.parentElement;
            newActivePuzzle.parentElement.parentElement.style.maxHeight = ((newActiveList.childElementCount / 4) + ((newActiveList.childElementCount / 4) % 4 === 0 ? 0 : 1)) * newActivePuzzle.offsetHeight + 'px';
            let plusMinus = newActiveList.previousSibling.querySelector('.fas');

            lists.map(list => {
                if (list.style.maxHeight === '') {
                    let icon = list.previousSibling.querySelector('.fas');
                    icon.classList.remove('fa-minus');
                    icon.classList.add('fa-plus')
                }
                return null;
            });

            if (newActiveList.style.maxHeight !== '' && plusMinus.classList.contains('fa-plus')) {
                plusMinus.classList.toggle('fa-plus');
                plusMinus.classList.toggle('fa-minus');
            }

            this.props.setActivePuzzle(puzzle);
            this.props.hideAlert();
        };
    }

    render() {
        let puzzles = Object.keys(purePuzzles).map(id => purePuzzles[id]);
        let allCommands = [...new Set(puzzles.map(puzzle => puzzle.command))];
        const renderPuzzles = (matchedPuzzles, language) => {
            const matchedPuzzle = matchedPuzzles[0];
            const direction = matchedPuzzle.rotate ? ['s', 'w', 'n', 'e'][matchedPuzzle.rotate / 90] : 's';
            return <img onClick={this.setActivePuzzle} key={matchedPuzzle.path[language]}
                        data-id={matchedPuzzle.id}
                        data-direction={direction}
                        style={{
                            'cursor': 'pointer',
                            'width': '33%',
                            'height': 'auto',
                            'transform': 'rotate(' + matchedPuzzle.rotate + 'deg)'
                        }}
                        src={"/akademia/image/puzzles/" + matchedPuzzle.path[language]} alt=""/>
        };

        let allPuzzles = <LanguageContext.Consumer>
            {({language}) =>
                React.createElement('ul', {className: 'help-list'},
                    allCommands.map((command, i) => {
                        let key = allCommands[i] + '' + i;
                        let matchedPuzzles = puzzles.filter(puzzle => puzzle.command === command);
                        matchedPuzzles = matchedPuzzles[0].command === 'biale_pole_pomoc' ? [...new Set().add(matchedPuzzles[0])] : matchedPuzzles;

                        return React.createElement('li', {className: matchedPuzzles[0].class, key: key},
                            <div className="command-name"><span>{language[matchedPuzzles[0].command]}</span>
                                <div className="sets-container">
                                    {matchedPuzzles[0].set ?
                                        <React.Fragment>
                                            <i className="fas fa-shopping-cart"/><span
                                            className="set">{language['kup_zestaw']}</span>
                                            {matchedPuzzles[0].set.map(set =>
                                                <a key={set.set} className="set-button" target='_blank' href={set.href}>
                                                    {language[set.set]}</a>)}
                                        </React.Fragment>
                                        : ''}
                                </div>
                            </div>,
                            <div className="help-content">
                                {renderPuzzles(matchedPuzzles, language['jezyk'])}
                                <div
                                    className="description-text">{language[matchedPuzzles[0].description]}{matchedPuzzles[0].pageLink ?
                                    <a target='_blank'
                                       href={matchedPuzzles[0].pageLink.href}>{matchedPuzzles[0].pageLink.text}</a> : ''}</div>
                            </div>
                        )
                    })
                )
            }
        </LanguageContext.Consumer>;

        return (
            <div className='right-menu-details-container' id={this.props.id} style={this.props.style}>
                <div className='right-menu-details-container-content'>
                    {allPuzzles}
                </div>
            </div>

        )
    }
}

export default connect(
    state => ({}),
    {setActivePuzzle, hideAlert}
)(RightMenuDetailsHelp);



// WEBPACK FOOTER //
// ./src/RightMenu/RightMenuDetailsHelp.js